import React from 'react'
import config from '../../../../config.json'

class ConfigProvider {
  config = config.data
}

export { ConfigProvider }
